export function clearEmptyField<T>(obj: T): T {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== null) {
      (acc as Record<string, T>)[key] = obj[key];
    }
    return acc;
  }, {} as T);
}
